export class NewRequisitionSkills {
    educations: any = [];
    experiences: any = [];
    technicalSkills: any = [];
    softSkills: any = [];
    otherSkills: any = [];
    operationalSkills: any = [];
    certifications: any = [];
}